@use '../../../scss/global/border';
@use '../../../scss/global/spacing';
@use '../../../scss/global/color';
@use '../../../scss/global/typography';

@use './passcode.mixins' as mixins;
@use './passcode.vars' as *;

:host {
  display: flex;
  flex-direction: column;
  gap: spacing.$spacer-1;

  @include mixins.passcode-text;
  @include mixins.passcode-header;
  @include mixins.passcode-container;
  @include mixins.passcode-input;
  @include mixins.passcode-description;
}

:host(.disabled) {
  .input-container {
    input {
      color: var(--text-color-disabled);
    }
  }

  fds-description {
    --text-color-default: var(--text-color-disabled);
    --description-icon-color: var(--text-color-disabled);
  }
}

:host(:not(.disabled)) {
  .input-container {
    &:hover {
      background-color: var(--background-color-hover);
    }

    &:not(:focus-within) {
      &::after {
        content: '';
        position: absolute;
        height: 2px;
        width: 100%;
        left: 0;
        bottom: 0;
        background-color: var(--bottom-border-color);
      }
    }

    input {
      &::placeholder {
        color: var(--placeholder-color);
      }
    }
  }
}
